// extracted by mini-css-extract-plugin
export default {"bankID":"styles_bankID__Eeoyk","cancelButton":"styles_cancelButton__ZZvAm"};